import React from 'react';

interface IInfoStepProps {}

const InfoStep: React.FC<React.PropsWithChildren<React.PropsWithChildren<IInfoStepProps>>> = ({}) => {
  return (
    <div className="grid gap-5 px-5">
      <p>You can request from the stylist to change the services</p>

      <p>
        If the deposit required for your new package is less than the deposit
        paid for your current package, the difference will be placed as a credit
        on your Flayr account so you can reuse it for another booking within the
        next 6 months.
      </p>
    </div>
  );
};
export default InfoStep;
